import { motion } from 'framer-motion';
import { motionSlideIn } from 'utils';
import HomeLink from './home-link';
import Toolbar from './toolbar';

const ServiceHeader2 = () => (
  <motion.header
    id='header'
    variants={motionSlideIn('down', 'tween', 0.5, 0.75)}
    initial='hidden'
    animate='show'
    className='absolute top-0 left-0 right-0 z-[50] flex h-[80px] items-center bg-transparent px-[24px] py-[12px]'
  >
    <main className='mx-[96px] flex w-full items-center justify-between space-x-[12px]'>
      <HomeLink />
      <Toolbar />
    </main>
  </motion.header>
);

export default ServiceHeader2;
